import { plural } from '../../../../shared/helpers/plural';
import { queryClient } from '../../../ReactQuery';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { post } from '../../../redux/api';
import type {
  AddReleaseGroupsToTeamRequest,
  AddReleaseGroupsToTeamResponse,
} from '../../../../shared/types/routes/teams';

import { getTeamQueryKey } from './useTeam';
import { getBaseTeamReleaseGroupsQueryKey } from './useTeamReleaseGroups';

type AddReleaseGroupsToTeamVariables = {
  teamId: number;
  releaseGroupIds: number[];
};

//  Actual function to add release groups to a team
async function addReleaseGroupsToTeam({ teamId, releaseGroupIds }: AddReleaseGroupsToTeamVariables) {
  const response = await post<AddReleaseGroupsToTeamRequest, AddReleaseGroupsToTeamResponse>(`/api/teams/${teamId}/release-groups`, {
    ids: releaseGroupIds,
  });
  return response.data;
}

/**
 * Hook for adding release groups to a team.
 */
export default function useAddReleaseGroupsToTeam() {
  return useToastedMutation({
    mutationFn: addReleaseGroupsToTeam,
    successToastMessage: (_response, variables: AddReleaseGroupsToTeamVariables) => {
      const count = variables.releaseGroupIds.length;
      return `Added ${count} ${plural(count, 'release group')} to team.`;
    },
    errorToastMessage: 'Failed to add release groups to team.',
    onSuccess: (_response, variables: AddReleaseGroupsToTeamVariables) => {
      // Re-fetch the team to get updated release groups
      queryClient.invalidateQueries({ queryKey: getTeamQueryKey(variables.teamId) });
      queryClient.invalidateQueries({ queryKey: getBaseTeamReleaseGroupsQueryKey(variables.teamId) });
    },
  });
}
